import { PayloadAction } from '@reduxjs/toolkit';

import { IErrorToastMessage } from '../../core/interfaces/IErrorToastMessage';

export const ErrorMessageReducer = {
	toggleError: (
		state: IErrorToastMessage,
		action: PayloadAction<IErrorToastMessage>
	) => {
		state.show = action.payload.show;
		state.title = action.payload.title;
		state.type = action.payload.type;
		state.action = action.payload.action;
		state.detail = action.payload.detail;
		state.key = action.payload.key;
		state.model = action.payload.model;
		state.metadata = action.payload.metadata;
	},
};
